<template>
  <div class="card no-body">
    <div class="card-header d-flex">
      <h5 class="h3 mb-0">Metadata</h5>
      <div class="ml-auto p-1">
        <b-input-group size="sm">
          <b-form-input
            v-model="searchValue"
            type="search"
            placeholder="Search"
          ></b-form-input>
        </b-input-group>
      </div>
    </div>

    <!-- Metadata -->
    <div v-if="metadata">
        <b-list-group flush class="scrollable-list-group">
            <b-list-group-item v-for="item in filterItem()" v-bind:key="item.id" class="d-flex justify-content-between align-items-center">
                <span><small>{{item[0]}}:</small></span>
                <span><small>{{item[1]}}</small></span>
            </b-list-group-item>
        </b-list-group>
    </div>
    <div v-else class="text-center p-3">
        No metadata for this item
    </div>

  </div>
</template>
<script>
export default {
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      searchValue: '',
    };
  },
  methods: {
    filterItem() {
      if (!this.entity.getExpandedMetadataMap() || this.entity.getExpandedMetadataMap().getLength() === 0) {
        return undefined;
      }
      const data = this.entity.getExpandedMetadataMap().entries();
      if (this.searchValue.trim() !== '') {
        return Object.values(data)[1].filter((item) => {
          const itemFilter = item.filter((itemSep) => itemSep.toLowerCase().match(new RegExp(this.searchValue.toLowerCase(), 'g')));
          return itemFilter.length > 0;
        });
      }
      return data;
    },
  },
  computed: {
    metadata() {
      if (!this.entity.getExpandedMetadataMap() || this.entity.getExpandedMetadataMap().getLength() === 0) {
        return undefined;
      }
      return this.entity.getExpandedMetadataMap().entries();
    },

  },
};
</script>
<style>
.scrollable-list-group {
    max-height: 500px;
    overflow:scroll;
    -webkit-overflow-scrolling: touch;
}
</style>
